var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('my-navbar'),_vm._v(" "),_c('div',{attrs:{"id":"content"}},[_c('b-container',{attrs:{"fluid":""}},[_c('router-view',{key:_vm.$route.name})],1)],1),_vm._v(" "),_c('my-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f9d2fa8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = Y8Tb
// module chunks = 1